module.exports = __webpack_public_path__ + "img/slider-image-02.7bcaa35c.png";